"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Notifications_1 = require("../../Core/Notifications");
var Body_1 = require("../../Core/Body");
var Languages_1 = require("../../Core/Languages");
exports.GuestModal = function () {
  var Selector = {
    MODAL: '#GuestModal',
    FORM: '#step2modalForm',
    CONTINUE_AS_GUEST_BTN: '#continueAsGuestBtn',
    LOGIN_WHEN_USER_IS_GUEST_BTN: '#login-when-user-is-guest',
    REMIND_PASSWORD_BTN: '#step2-remind-password',
    ALLOW_GUEST_CHECKER: '#allowGuestContinue',
    LAST_STEP_BTN: '#GuestExistCheck'
  };
  function remindPassword(event) {
    event.preventDefault();
    var urlLang = Languages_1.getCurrentLanguageUrl;
    $.post(urlLang + "/reset_password_ajax", $(Selector.FORM).serialize(), function (json) {
      Notifications_1.Notifications.add(json.msg, json.status === "success" ? "info" : "error", {
        lifespan: 10000
      });
    });
  }
  Body_1.$body.on('click', Selector.REMIND_PASSWORD_BTN, remindPassword);
}();
exports.setEmail = function (email, selector) {
  $(selector).val(email);
};
exports.setFormSerialized = function (FormSerialized, selector) {
  $(selector).val(FormSerialized);
};